import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
`

const Text = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    font-size: 1.4rem;
    text-align: center;
    color: ${theme.palette.white};
    display: none;
    ${theme.maxMedia('sm')} {
      display: block;
    }
  `}
`

export default {
  Wrapper,
  Text,
}
